import React, { useState } from 'react';
import './GroupStatusModal.css';

const STATUS_OPTIONS = [
    { value: 'CURRENT', label: 'Watching', emoji: '▶️' },
    { value: 'COMPLETED', label: 'Completed', emoji: '✅' },
    { value: 'PLANNING', label: 'Planning', emoji: '📅' },
    { value: 'PAUSED', label: 'On Hold', emoji: '⏸️' },
    { value: 'DROPPED', label: 'Dropped', emoji: '❌' }
];

const GroupStatusModal = ({ isOpen, group, optimisticUpdates, onConfirm, onCancel }) => {
    const [mode, setMode] = useState('all'); // 'all' or 'convert'
    const [targetStatus, setTargetStatus] = useState('CURRENT');
    const [fromStatus, setFromStatus] = useState('PLANNING');
    const [toStatus, setToStatus] = useState('CURRENT');

    if (!isOpen || !group) return null;

    // Get effective status (considering optimistic updates)
    const getEffectiveStatus = (anime) => {
        return optimisticUpdates?.get(anime.media.id) || anime.status;
    };

    const affectedCount = mode === 'all'
        ? group.anime.length
        : group.anime.filter(a => getEffectiveStatus(a) === fromStatus).length;

    const handleConfirm = () => {
        onConfirm(
            group.id,
            mode,
            mode === 'all' ? null : fromStatus,
            mode === 'all' ? targetStatus : toStatus
        );
    };

    return (
        <div className="modal-overlay" onClick={onCancel}>
            <div className="bulk-modal" onClick={(e) => e.stopPropagation()}>
                <h2>⚙️ Bulk Status Change</h2>
                <p className="group-name">{group.name}</p>

                {/* Mode selector */}
                <div className="mode-selector">
                    <button
                        className={`mode-btn ${mode === 'all' ? 'active' : ''}`}
                        onClick={() => setMode('all')}
                    >
                        Change All
                    </button>
                    <button
                        className={`mode-btn ${mode === 'convert' ? 'active' : ''}`}
                        onClick={() => setMode('convert')}
                    >
                        Convert
                    </button>
                </div>

                {/* Status selectors */}
                {mode === 'all' ? (
                    <div className="status-selector">
                        <label>Change all anime to:</label>
                        <select value={targetStatus} onChange={(e) => setTargetStatus(e.target.value)}>
                            {STATUS_OPTIONS.map(opt => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.emoji} {opt.label}
                                </option>
                            ))}
                        </select>
                    </div>
                ) : (
                    <div className="convert-selector">
                        <div>
                            <label>From:</label>
                            <select value={fromStatus} onChange={(e) => setFromStatus(e.target.value)}>
                                {STATUS_OPTIONS.map(opt => (
                                    <option key={opt.value} value={opt.value}>
                                        {opt.emoji} {opt.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <span className="arrow">→</span>
                        <div>
                            <label>To:</label>
                            <select value={toStatus} onChange={(e) => setToStatus(e.target.value)}>
                                {STATUS_OPTIONS.map(opt => (
                                    <option key={opt.value} value={opt.value}>
                                        {opt.emoji} {opt.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}

                {/* Affected count */}
                <div className={`affected-count ${affectedCount === 0 ? 'warning' : ''}`}>
                    {affectedCount === 0 ? (
                        <span>⚠️ No anime match this criteria</span>
                    ) : (
                        <span>✓ Will update {affectedCount} anime</span>
                    )}
                </div>

                {/* Action buttons */}
                <div className="modal-actions">
                    <button className="cancel-btn" onClick={onCancel}>
                        Cancel
                    </button>
                    <button
                        className="confirm-btn"
                        onClick={handleConfirm}
                        disabled={affectedCount === 0}
                    >
                        Confirm Update
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GroupStatusModal;
